import React, { useEffect, useMemo, useState } from 'react'
import { createPortal } from 'react-dom'
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import * as reportCrud from '../../../configurations/crud/reportCrud'
import { useToast } from '../../controls/Toast/ToastService';
import {
    MdErrorOutline,
    MdOutlineTag,
    MdOutlineConfirmationNumber,
    MdOutlinePhone,
    MdOutlineCake,
    MdOutlineHome,
    MdCheck,
    MdClose,
    MdOutlineSummarize,
    MdOutlineLocalPrintshop,
    MdArrowBack,
    MdSearch,
    MdOutlineTagFaces,
} from 'react-icons/md';
import { Link, useParams } from 'react-router-dom';
import { PAGE_SIZE } from '../../../configurations/initUrls';
import Paging from '../../controls/Paging';
import ConfirmOnline from './ConfirmOnline';
import { EOPDRegisteredStatusBg, GetEOPDRegisterstatus, GetEOPDRegisterStatusName } from '../../../configurations/enums/EOPDRegisteredStatus';
import StatusContainer from '../../controls/StatusContainer';
import { IoCheckmarkCircleOutline } from 'react-icons/io5';
import LoadingContainer from '../../controls/LoadingContainer';
import { GetEGenderName } from '../../../configurations/enums/EGender';
import useGlobalLoader from '../../../configurations/useGlobalLoader';
import Empty from '../../controls/Empty';
import { printDailySummary, summarize, money, prettyDate } from './printDailySummary';

export default function LookOutRegistered({ isActive, searchTerm, isSearch, centerId, centerName, forDate }) {

    const { start, end } = useGlobalLoader()
    const toast = useToast()
    const [LastPage, setLastPage] = useState(1);
    const [pagingData, setPagingData] = useState();
    const [loding, setLoding] = useState(false)
    const [userData, setUserData] = useState([]);
    const [lodingCrud, setLodingCrud] = useState(false)
    const [isOpenAdd, setIsOpenAdd] = useState(false)
    const [addData, setAddData] = useState()
    const [currentPage, setCurrentPage] = useState(1)

    // ===== summary state =====
    const [isOpenSummary, setIsOpenSummary] = useState(false)
    const [lodingSummary, setLodingSummary] = useState(false)
    const [summaryData, setSummaryData] = useState()
    const [rates, setRates] = useState({ Normal: '', NewEntry: '', Emergency: '' })
    const [rateError, setRateError] = useState('')
    const [printing, setPrinting] = useState(false)

    const sum = useMemo(() => summarize(summaryData, GetEOPDRegisterStatusName), [summaryData])

    // center ka naam — string prop ya {name} / {centerName} object, dono chalega
    const centerTitle = String(
        (typeof centerName === 'object' && centerName !== null)
            ? (centerName.centerName || centerName.name || '')
            : (centerName || '')
    ).trim()

    useEffect(() => {
        if (isActive && centerId && forDate) {
            onSearch()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSearch, centerId, forDate])

    // center ya date badle to purana summary result hata do
    useEffect(() => {
        setSummaryData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [centerId, forDate])

    // modal khule to background scroll band
    useEffect(() => {
        if (isOpenSummary) {
            const prev = document.body.style.overflow
            document.body.style.overflow = 'hidden'
            return () => { document.body.style.overflow = prev }
        }
    }, [isOpenSummary])

    const OnPageChange = (e) => {
        if (isActive && centerId && forDate) {
            setCurrentPage(e)
            GetTodaysRegistered({
                CenterId: centerId,
                PageNo: e,
                PageSize: PAGE_SIZE,
                SearchTerm: searchTerm,
                ForDate: forDate
            })
        }
    }

    const onSearch = () => {
        GetTodaysRegistered({
            CenterId: centerId,
            PageNo: 1,
            PageSize: PAGE_SIZE,
            SearchTerm: searchTerm,
            ForDate: forDate
        })
    }

    const GetTodaysRegistered = (params) => {
        setLoding(true)
        start()
        opdRegisteredCrud.GetForDateRegistered(params).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setUserData(mdata.data)
                setPagingData(mdata.paging)
                setLastPage(mdata.paging.pageCount)
            } else {
                setPagingData()
                setLastPage(1)
                setUserData([])
                toast.open(mdata.result.message, <MdErrorOutline />, "danger")
            }
            setLoding(false)
            end()
        }).catch(errors => {
            setPagingData()
            setLastPage(1)
            setUserData([])
            setLoding(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    const confirmOnline = (param, setValues) => {
        setLodingCrud(true)
        start()
        opdRegisteredCrud.ConfirmOnline(param).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setValues({
                    Id: 0,
                    Comment: "N/A",
                    BloodPressure: "N/A",
                    PatientBond: "Cash",
                    PatientType: "Normal",
                    Weight: 0,
                    PatientName: "",
                    Mobile: "",
                })
                setIsOpenAdd(false)
                onSearch()
                toast.open(
                    <div className='flex flex-col'>
                        <span>Confirmed Successfully! Ref No: {mdata.data.id}</span>
                        <a href={`/#/checkconfirmed/${mdata.data.id}`} target='_blank' className='hover:underline text-blue-700 font-semibold' >Click to get confirmation details</a>
                    </div>
                    , <IoCheckmarkCircleOutline />, "success", 30000)
            } else {
                toast.open(mdata.result.message, <MdErrorOutline />, "danger")
                setIsOpenAdd(false)
            }
            setLodingCrud(false)
            end()
        }).catch(errors => {
            setLodingCrud(false)
            end()
            setIsOpenAdd(false)
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    /* ===================== summary: open / search / print ===================== */

    const openSummary = () => {
        if (!centerId || !forDate) {
            toast.open("Pehle center aur date select karein", <MdErrorOutline />, "danger")
            return
        }
        setRateError('')
        setIsOpenSummary(true)
    }

    const searchSummary = () => {
        const Normal = Number(rates.Normal)
        const NewEntry = Number(rates.NewEntry)
        const Emergency = Number(rates.Emergency)
        if (rates.Normal === '' || rates.NewEntry === '' || rates.Emergency === '' || Number.isNaN(Normal) || Number.isNaN(Emergency) || Number.isNaN(NewEntry)) {
            setRateError("Fill all three Normal, New Entry and Emergency.")
            return
        }
        setRateError('')
        setLodingSummary(true)
        start()
        reportCrud.DailySummary({
            centerId: centerId,
            ForDate: forDate,
            Normal: Normal,
            NewEntry: NewEntry,
            Emergency: Emergency
        }).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setSummaryData(mdata)
            } else {
                setSummaryData()
                toast.open(mdata.result.message, <MdErrorOutline />, "danger")
            }
            setLodingSummary(false)
            end()
        }).catch(errors => {
            setSummaryData()
            setLodingSummary(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    const doPrint = async () => {
        if (!summaryData || printing) return
        setPrinting(true)
        const mode = await printDailySummary({
            data: summaryData,
            params: {
                centerName: centerTitle,
                ForDate: forDate,
                Normal: Number(rates.Normal),
                NewEntry: Number(rates.NewEntry),
                Emergency: Number(rates.Emergency)
            },
            brand: centerTitle || "Daily Collection Register",
            statusName: GetEOPDRegisterStatusName,
        })
        setPrinting(false)
        if (mode === "unsupported") {
            toast.open("Is device par print dialog available nahi hai.", <MdErrorOutline />, "danger", 5000)
        }
    }

    const bondTone = (bond) => {
        const b = String(bond || "").toLowerCase()
        if (b === "upi") return "bg-indigo-50 text-indigo-700 ring-indigo-200"
        if (b === "cash") return "bg-teal-50 text-teal-700 ring-teal-200"
        return "bg-gray-100 text-gray-600 ring-gray-200"
    }

    const inputCls =
        'mt-1 w-full rounded-lg border border-sky-200 bg-sky-50/60 px-3 py-2.5 text-gray-800 outline-none ' +
        'transition focus:border-sky-500 focus:bg-white focus:ring-2 focus:ring-sky-200'

    // Confirm button (pending) OR status badge
    const renderAction = (item) => (
        // item.status == 2 ? (
        //     <button
        //         type="button"
        //         title="Pending"
        //         onClick={() => { setAddData(item.id); setIsOpenAdd(!isOpenAdd) }}
        //         className="inline-flex items-center gap-1.5 rounded-lg bg-brand-500 px-3 py-1.5 text-sm font-medium text-white transition hover:bg-brand-600 focus:outline-none focus:ring-2 focus:ring-brand-500 active:scale-95"
        //     >
        //         <MdCheck className="text-base" /> Confirm
        //     </button>
        // ) : (
        <StatusContainer bg={EOPDRegisteredStatusBg(item.status)} text={GetEOPDRegisterStatusName(item.status)} />
        // )
    )

    return (
        <div className="text-gray-700">

            {/* ===== summary button ===== */}
            <div className="mb-2 flex justify-end px-2 sm:px-0">
                <button
                    type="button"
                    onClick={openSummary}
                    className="inline-flex items-center gap-1.5 rounded-lg bg-sky-600 px-3 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-sky-300 active:scale-95"
                >
                    <MdOutlineSummarize className="text-base" /> Summary
                </button>
            </div>

            <Paging LastPage={LastPage} CurrentPage={currentPage} OnPageChange={OnPageChange} pagingData={pagingData}>

                {loding ? (
                    <LoadingContainer text="Fetching..." />
                ) : userData.length > 0 ? (
                    <>
                        {/* ===== desktop table ===== */}
                        <div className="hidden overflow-x-auto rounded-xl ring-1 ring-gray-100 sm:block">
                            <table className="w-full border-collapse text-left text-sm text-gray-500">
                                <thead>
                                    <tr className="bg-gray-100 text-xs uppercase tracking-wide text-gray-500">
                                        <th scope="col" className="px-3 py-3 font-semibold">
                                            <span className="flex items-center gap-1"><MdOutlineTag className="text-sm" /> Ref.No</span>
                                        </th>
                                        <th scope="col" className="px-3 py-3 font-semibold">
                                            <span className="flex items-center gap-1"><MdOutlineConfirmationNumber className="text-sm" /> OPD No.</span>
                                        </th>
                                        <th scope="col" className="px-3 py-3 font-semibold">Name</th>
                                        <th scope="col" className="px-3 py-3 font-semibold">
                                            <span className="flex items-center gap-1"><MdOutlinePhone className="text-sm" /> Phone</span>
                                        </th>
                                        <th scope="col" className="px-3 py-3 font-semibold">
                                            <span className="flex items-center gap-1"><MdOutlineCake className="text-sm" /> Age</span>
                                        </th>
                                        <th scope="col" className="px-3 py-3 font-semibold">Action</th>
                                        <th scope="col" className="px-3 py-3 font-semibold">
                                            <span className="flex items-center gap-1"><MdOutlineHome className="text-sm" /> Address</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-100">
                                    {userData.map((item, index) => (
                                        <tr key={item.id ?? index} className="bg-white hover:bg-gray-50">
                                            <td className="px-3 py-2.5">{item.id}</td>
                                            <td className="px-3 py-2.5">{item.opdNumberAlloted}</td>
                                            <td className="whitespace-nowrap px-3 py-2.5 font-bold text-gray-800">
                                                {item.patientName} <span className="text-[9px] font-normal text-gray-400">({GetEGenderName(item.gender)})</span>
                                            </td>
                                            <td className="px-3 py-2.5">
                                                {item.mobile
                                                    ? <a href={`tel:${item.mobile}`} className="hover:text-brand-600 hover:underline">{item.mobile}</a>
                                                    : "—"}
                                            </td>
                                            <td className="px-3 py-2.5">{item.age}</td>
                                            <td className="w-28 px-3 py-2.5">{renderAction(item)}</td>
                                            <td className="whitespace-nowrap px-3 py-2.5">{item.patientAddress}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* ===== mobile cards ===== */}
                        <div className="space-y-2 p-2 text-left sm:hidden">
                            {userData.map((item, index) => (
                                <div key={item.id ?? index} className="rounded-xl border border-gray-100 bg-white p-3 shadow-sm">
                                    <div className="flex items-start justify-between gap-2">
                                        <div className="min-w-0">
                                            <div className="font-bold text-gray-900">
                                                {item.patientName} <span className="text-xs font-normal text-gray-400">({GetEGenderName(item.gender)})</span>
                                            </div>
                                            <div className="mt-0.5 flex flex-wrap items-center gap-x-2 gap-y-0.5 text-xs text-gray-500">
                                                <span className="flex items-center gap-0.5"><MdOutlineTag className="text-sm" /> {item.id}</span>
                                                <span className="flex items-center gap-0.5"><MdOutlineConfirmationNumber className="text-sm" /> {item.opdNumberAlloted}</span>
                                                <span className="flex items-center gap-0.5"><MdOutlineCake className="text-sm" /> {item.age} Y</span>
                                            </div>
                                        </div>
                                        <div className="shrink-0">{renderAction(item)}</div>
                                    </div>
                                    <div className="mt-2 space-y-1 text-xs text-gray-600">
                                        <div className="flex items-center gap-1">
                                            <MdOutlinePhone className="shrink-0 text-sm text-gray-400" />
                                            {item.mobile
                                                ? <a href={`tel:${item.mobile}`} className="hover:text-brand-600 hover:underline">{item.mobile}</a>
                                                : "—"}
                                        </div>
                                        <div className="flex items-start gap-1">
                                            <MdOutlineHome className="mt-0.5 shrink-0 text-sm text-gray-400" />
                                            <span>{item.patientAddress}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                ) : (
                    <Empty>No Items Found.</Empty>
                )}
            </Paging>

            <div className="pb-4" />

            <ConfirmOnline confirmOnline={confirmOnline} id={addData} isOpen={isOpenAdd} setIsOpen={setIsOpenAdd} loding={lodingCrud} />

            {/* ======================= SUMMARY MODAL ======================= */}
            {isOpenSummary ? createPortal((
                <div
                    className="fixed inset-0 z-[9999] flex items-end justify-center overflow-y-auto bg-gray-900/60 backdrop-blur-sm sm:items-center sm:p-4"
                    onClick={() => !lodingSummary && setIsOpenSummary(false)}
                    role="presentation"
                >
                    <div
                        role="dialog"
                        aria-modal="true"
                        aria-label="Daily summary"
                        onClick={(e) => e.stopPropagation()}
                        className="flex max-h-[92vh] w-full max-w-2xl flex-col rounded-t-2xl bg-white shadow-2xl sm:my-auto sm:rounded-2xl"
                        style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
                    >
                        {/* header */}
                        <div className="flex shrink-0 items-start justify-between gap-3 rounded-t-2xl bg-gradient-to-r from-sky-700 to-cyan-500 px-5 py-4 text-white">
                            <div>
                                <h3 className="text-lg font-bold">Daily summary</h3>
                                <p className="text-xs text-sky-100">
                                    {prettyDate(forDate)}{centerTitle ? ` · ${centerTitle}` : ''}
                                </p>
                            </div>
                            <button
                                type="button"
                                onClick={() => setIsOpenSummary(false)}
                                disabled={lodingSummary}
                                className="rounded-lg p-1 text-white/80 transition hover:bg-white/20 hover:text-white disabled:opacity-50"
                                aria-label="Close"
                            >
                                <MdClose className="text-xl" />
                            </button>
                        </div>

                        {/* rate inputs */}
                        <div className="shrink-0 border-b border-gray-100 px-5 py-4">
                            <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 sm:items-end">
                                <label className="block">
                                    <span className="text-[11px] font-semibold uppercase tracking-wider text-sky-700">Normal</span>
                                    <input
                                        type="number"
                                        inputMode="decimal"
                                        autoFocus
                                        className={inputCls}
                                        value={rates.Normal}
                                        onChange={(e) => setRates({ ...rates, Normal: e.target.value })}
                                        onKeyDown={(e) => e.key === 'Enter' && searchSummary()}
                                    />
                                </label>
                                <label className="block">
                                    <span className="text-[11px] font-semibold uppercase tracking-wider text-sky-700">New entry</span>
                                    <input
                                        type="number"
                                        inputMode="decimal"
                                        className={inputCls}
                                        value={rates.NewEntry}
                                        onChange={(e) => setRates({ ...rates, NewEntry: e.target.value })}
                                        onKeyDown={(e) => e.key === 'Enter' && searchSummary()}
                                    />
                                </label>
                                <label className="block">
                                    <span className="text-[11px] font-semibold uppercase tracking-wider text-sky-700">Emergency</span>
                                    <input
                                        type="number"
                                        inputMode="decimal"
                                        className={inputCls}
                                        value={rates.Emergency}
                                        onChange={(e) => setRates({ ...rates, Emergency: e.target.value })}
                                        onKeyDown={(e) => e.key === 'Enter' && searchSummary()}
                                    />
                                </label>
                                <button
                                    type="button"
                                    onClick={searchSummary}
                                    disabled={lodingSummary}
                                    className="mt-1 inline-flex items-center justify-center gap-1.5 rounded-lg bg-sky-600 px-4 py-2.5 text-sm font-bold text-white transition hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-sky-300 active:scale-95 disabled:opacity-60"
                                >
                                    <MdSearch className="text-lg" /> {lodingSummary ? 'Searching…' : 'Search'}
                                </button>
                            </div>
                            {rateError ? (
                                <p className="mt-2 rounded-lg bg-amber-50 px-3 py-2 text-xs text-amber-700 ring-1 ring-amber-200">{rateError}</p>
                            ) : null}
                        </div>

                        {/* result */}
                        <div className="min-h-0 flex-1 overflow-y-auto px-5 py-4">
                            {lodingSummary ? (
                                <LoadingContainer text="Fetching..." />
                            ) : !summaryData ? (
                                <Empty>Rate daal kar Search karein.</Empty>
                            ) : (
                                <>
                                    <div className="grid grid-cols-2 gap-2 lg:grid-cols-4">
                                        {[
                                            { l: "Registered", v: sum.registeredCount, n: `${sum.byStatus.length} status group`, c: "bg-sky-500" },
                                            { l: "Confirmed", v: sum.confirmedCount, n: `${sum.confirmed.length} entries`, c: "bg-sky-600" },
                                            { l: "Total Cash", v: money(sum.totalCash), n: `${sum.cashCount} patients`, c: "bg-teal-500" },
                                            { l: "Total UPI", v: money(sum.totalUpi), n: `${sum.upiCount} patients`, c: "bg-indigo-500" },
                                        ].map((k, i) => (
                                            <div key={i} className="relative overflow-hidden rounded-xl bg-white p-3 ring-1 ring-gray-100">
                                                <span className={`absolute inset-x-0 top-0 h-1 ${k.c}`} />
                                                <p className="text-[10px] font-semibold uppercase tracking-wide text-gray-400">{k.l}</p>
                                                <p className="mt-0.5 text-lg font-bold leading-tight text-gray-800">{k.v}</p>
                                                <p className="text-[11px] text-gray-400">{k.n}</p>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="mt-3 rounded-xl bg-gradient-to-r from-sky-50 to-cyan-50 p-4 ring-1 ring-sky-100">
                                        <div className="flex items-baseline justify-between">
                                            <span className="text-xs font-semibold uppercase tracking-wide text-sky-700">Total amount</span>
                                            <span className="text-2xl font-extrabold text-sky-800">{money(sum.totalAmount)}</span>
                                        </div>
                                        <div className="mt-3 flex h-2.5 overflow-hidden rounded-full bg-gray-200">
                                            <span className="bg-teal-500" style={{ width: `${sum.cashShare}%` }} />
                                            <span className="bg-indigo-500" style={{ width: `${sum.upiShare}%` }} />
                                            <span className="bg-gray-400" style={{ width: `${sum.otherShare}%` }} />
                                        </div>
                                        <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-[11px] text-gray-500">
                                            <span className="flex items-center gap-1.5"><i className="h-2 w-2 rounded-sm bg-teal-500" /> Cash {sum.cashShare.toFixed(1)}%</span>
                                            <span className="flex items-center gap-1.5"><i className="h-2 w-2 rounded-sm bg-indigo-500" /> UPI {sum.upiShare.toFixed(1)}%</span>
                                            {sum.totalOther ? (
                                                <span className="flex items-center gap-1.5"><i className="h-2 w-2 rounded-sm bg-gray-400" /> Other {sum.otherShare.toFixed(1)}%</span>
                                            ) : null}
                                        </div>
                                    </div>

                                    {/* registration status */}
                                    <h4 className="mt-5 border-b border-sky-100 pb-2 text-xs font-bold uppercase tracking-wide text-sky-700">
                                        Registration status
                                    </h4>
                                    <div className="mt-2 space-y-2">
                                        {sum.byStatus.map((r, i) => (
                                            <div key={i} className="flex items-center justify-between rounded-xl border border-gray-100 bg-white px-3 py-2.5">
                                                <StatusContainer bg={EOPDRegisteredStatusBg(r.status)} text={r.label} />
                                                <span className="text-base font-bold text-gray-800">{r.count}</span>
                                            </div>
                                        ))}
                                        <div className="flex items-center justify-between rounded-xl bg-sky-900 px-3 py-2.5 text-white">
                                            <span className="text-sm font-semibold">Total registered</span>
                                            <span className="text-base font-bold">{sum.registeredCount}</span>
                                        </div>
                                    </div>

                                    {/* confirmed */}
                                    <h4 className="mt-5 border-b border-sky-100 pb-2 text-xs font-bold uppercase tracking-wide text-sky-700">
                                        Confirmed collection
                                    </h4>
                                    <div className="mt-2 space-y-2 sm:hidden">
                                        {sum.confirmed.map((c, i) => (
                                            <div key={i} className="rounded-xl border border-gray-100 bg-white p-3 shadow-sm">
                                                <div className="flex items-start justify-between gap-3">
                                                    <div>
                                                        <p className="font-bold text-gray-900">{c.patientType}</p>
                                                        <span className={`mt-1 inline-block rounded-full px-2 py-0.5 text-[11px] font-semibold ring-1 ring-inset ${bondTone(c.patientBond)}`}>
                                                            {c.patientBond}
                                                        </span>
                                                    </div>
                                                    <div className="text-right">
                                                        <p className="text-base font-bold text-gray-800">{money(c.total)}</p>
                                                        <p className="text-[11px] text-gray-400">{c.count} patients</p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="mt-2 hidden overflow-x-auto rounded-xl ring-1 ring-gray-100 sm:block">
                                        <table className="w-full border-collapse text-left text-sm text-gray-500">
                                            <thead>
                                                <tr className="bg-gray-100 text-xs uppercase tracking-wide text-gray-500">
                                                    <th scope="col" className="px-3 py-3 font-semibold">Patient type</th>
                                                    <th scope="col" className="px-3 py-3 font-semibold">Mode</th>
                                                    <th scope="col" className="px-3 py-3 text-right font-semibold">Count</th>
                                                    <th scope="col" className="px-3 py-3 text-right font-semibold">Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-100">
                                                {sum.confirmed.map((c, i) => (
                                                    <tr key={i} className="bg-white hover:bg-gray-50">
                                                        <td className="px-3 py-2.5 font-semibold text-gray-800">{c.patientType}</td>
                                                        <td className="px-3 py-2.5">
                                                            <span className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ring-1 ring-inset ${bondTone(c.patientBond)}`}>
                                                                {c.patientBond}
                                                            </span>
                                                        </td>
                                                        <td className="px-3 py-2.5 text-right">{c.count}</td>
                                                        <td className="px-3 py-2.5 text-right font-bold text-gray-800">{money(c.total)}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot>
                                                <tr className="bg-sky-900 text-white">
                                                    <td className="px-3 py-2.5 font-semibold" colSpan={2}>Grand total</td>
                                                    <td className="px-3 py-2.5 text-right font-bold">{sum.confirmedCount}</td>
                                                    <td className="px-3 py-2.5 text-right font-bold">{money(sum.totalAmount)}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </>
                            )}
                        </div>

                        {/* footer */}
                        <div className="flex shrink-0 gap-2 border-t border-gray-100 px-5 py-3">
                            <button
                                type="button"
                                onClick={() => setIsOpenSummary(false)}
                                className="inline-flex flex-1 items-center justify-center gap-1.5 rounded-xl border border-gray-200 px-4 py-3 text-sm font-semibold text-gray-600 transition hover:bg-gray-50"
                            >
                                <MdArrowBack className="text-base" /> Close
                            </button>
                            <button
                                type="button"
                                onClick={doPrint}
                                disabled={!summaryData || lodingSummary || printing}
                                className="inline-flex flex-[2] items-center justify-center gap-2 rounded-xl bg-sky-600 px-4 py-3 text-sm font-bold text-white shadow-lg shadow-sky-200 transition hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-sky-300 active:scale-95 disabled:opacity-50"
                            >
                                <MdOutlineLocalPrintshop className="text-lg" /> Print
                            </button>
                        </div>
                    </div>
                </div>
            ), document.body) : null}
        </div>
    )
}